export * from './welcome.page'
